import React from 'react';

const Loadable = React.lazy(() => import('../../pages/User/User'));

export default Loadable;
